<template>
    <div>
        <p class="text-center" v-if="!-loading"><a @click.prevent.stop="dispatchWorkTicket()"
                                  href="">DISPATCH WORK TICKET</a></p>
        <p v-if="loading" class="text-center">Dispatching in progress. Please wait while we process your request...
            <span class="fa fa-sync fa-spin"></span>
        </p>
    </div>

</template>
<script>
import _ from "lodash";

export default {
    name: "ScheduleDispatch",
    props: {
        dateId: String,
        contacts: {
            type: Array,
            default: () => []
        },
        jobNum: {}
    },
    data() {
        return {
            contact: null,
            loading: false,
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            let app = this;
            axios.get('/api/work_orders/dispatch/schedule-date/' + this.dateId,)
                .then((response) => {
                    let date = response.data.data;
                    if (date.contact_name){
                        app.contact = {
                            name: date.contact_name,
                            phone: date.contact_phone,
                            email: date.contact_email,
                            notes: date.notes,
                        }

                    }
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })
        },
        dispatchWorkTicket() {
            if (this.contacts.length < 0 && !this.contact && !this.jobNum) {
                showMessage('e', 'Contacts is required!');
                return;
            }
            let app = this;
            app.loading = true;
            axios.post('/api/work_orders/dispatch/schedule-date/' + this.dateId)
                .then((response) => {
                    showMessage('s', `THE TICKET HAS BEEN DISPATCHED`)
                    app.loading = false
                    if (window.opener){
                        window.opener.location.reload()
                    }
                    setTimeout(function () {
                        window.location.reload();
                    }, 500)
                })
                .catch(error => {
                    app.loading = false
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })
        },

    }
}
</script>
<style scoped>

</style>
